import { useAppSelector } from '../../store/Hooks'
import { SectionView } from '../contract_tabs/NewContractAnalytics'
import Tile from '../layout/Tile'
import { IMenuItem, IRouteParameters } from '../routes/ContractDetails'
import RoutingManager from '../routing/Routing'
import { snackbar } from '../services/SnackbarService'
import ExpenseByTosSection from './ExpenseByTosSection'
import TotalExpenseByTosSection from './TotalExpenseByTosSection'
interface P {
    changeView: (view: SectionView) => void
    updateDataFlag: boolean
    setExportMenu: (items: IMenuItem[]) => void
}

const ExpensesByTosView = ({ changeView, updateDataFlag, setExportMenu }: P) => {
    const params = RoutingManager.getParams<IRouteParameters>(useAppSelector(s => s.session.routeParams))
    const triggerSnackbarError = (message: string) => {
        snackbar.show({ severity: 'error', text: message })
    }

    return (
        <Tile.Container style={{ maxHeight: '600px' }}>
            <Tile.Row flex={1} spacing={2} style={{ height: '100%' }}>
                <Tile.Column>
                    <TotalExpenseByTosSection
                        contractId={params?.contractId}
                        title='Total Expense by Type of Services (TOS)'
                        startDate={params?.startDate}
                        endDate={params?.endDate}
                        icon='close'
                        changeView={changeView}
                        triggerSnackbarError={triggerSnackbarError}
                        updateDataFlag={updateDataFlag}
                        setExportMenu={setExportMenu}
                    />
                </Tile.Column>
                <Tile.Column>
                    <ExpenseByTosSection
                        contractId={params?.contractId}
                        title='Expenses By Type Of Service'
                        startDate={params?.startDate}
                        endDate={params?.endDate}
                        triggerSnackbarError={triggerSnackbarError}
                        updateDataFlag={updateDataFlag}
                    />
                </Tile.Column>
            </Tile.Row>
        </Tile.Container>
    )
}
export default ExpensesByTosView
